// removed by extract-text-webpack-plugin
module.exports = {"container":"style__container___2-ZdJ","title":"style__title___1e_LL","detail":"style__detail___2927J","prop":"style__prop___1FEDS"};


//////////////////
// WEBPACK FOOTER
// ./src/views/graphInfoPanelView/style.less
// module id = 766
// module chunks = 0